import { render } from "./BaseTabs.vue?vue&type=template&id=7d9f63a3&scoped=true&lang=pug"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"

import "./BaseTabs.vue?vue&type=style&index=0&id=7d9f63a3&scoped=true&lang=scss"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9f63a3"]])

export default __exports__